import { ROUTES } from '@/constants/routes';

export interface FavoriteSubModule {
  systemName: string;
  moduleName: string;
  route: string;
  icon: string;
  titleKey: string;
  fallbackTitle: string;
}

/** Hårdkodade barnkort som inte kommer från /api/menu. */
export const FAVORITE_SUB_MODULES: FavoriteSubModule[] = [
  {
    systemName: 'deque',
    moduleName: 'map-services/track',
    route: ROUTES.DEQUE_TRACK,
    icon: 'MapIcon',
    titleKey: 'mapServices.track',
    fallbackTitle: 'Track',
  },
  {
    systemName: 'deque',
    moduleName: 'map-services/geofence',
    route: ROUTES.ADMIN_GEOFENCES,
    icon: 'MapPinIcon',
    titleKey: 'mapServices.geofence',
    fallbackTitle: 'Geofence',
  },
  {
    systemName: 'deque',
    moduleName: 'map-services/heatmap',
    route: ROUTES.ANALYSIS_HEATMAP,
    icon: 'FireIcon',
    titleKey: 'mapServices.heatmap',
    fallbackTitle: 'Heatmap',
  },
  {
    systemName: 'deque',
    moduleName: 'fleet/overview',
    route: ROUTES.FLEET_OVERVIEW,
    icon: 'TruckIcon',
    titleKey: 'fleet.overview',
    fallbackTitle: 'Fordonsflotta',
  },
  {
    systemName: 'deque',
    moduleName: 'fleet/unplug-events',
    route: ROUTES.FLEET_UNPLUG_EVENTS,
    icon: 'BoltSlashIcon',
    titleKey: 'unplugEvents.title',
    fallbackTitle: 'Urkopplingshistorik',
  },
  {
    systemName: 'deque',
    moduleName: 'fleet/economy-export',
    route: ROUTES.FLEET_ECONOMY_EXPORT,
    icon: 'CurrencyDollarIcon',
    titleKey: 'vehicleEconomy.exportTitle',
    fallbackTitle: 'Export fordonsekonomi',
  },
  {
    systemName: 'deque',
    moduleName: 'fleet/cost-invoices',
    route: ROUTES.FLEET_COST_INVOICES,
    icon: 'DocumentArrowUpIcon',
    titleKey: 'costInvoice.title',
    fallbackTitle: 'Kostnadsfakturaimport',
  },
  {
    systemName: 'deque',
    moduleName: 'fleet/vehicle-economy',
    route: ROUTES.FLEET_VEHICLE_ECONOMY,
    icon: 'ChartBarIcon',
    titleKey: 'vehicleCostAnalysis.title',
    fallbackTitle: 'Fordons ekonomi',
  },
  {
    systemName: 'deque',
    moduleName: 'organization/chart',
    route: ROUTES.ORGANIZATION_CHART,
    icon: 'BuildingOffice2Icon',
    titleKey: 'organizations.chart',
    fallbackTitle: 'Organisationsschema',
  },
  {
    systemName: 'deque',
    moduleName: 'organization/management',
    route: ROUTES.ADMIN_ORGANIZATIONS,
    icon: 'UserGroupIcon',
    titleKey: 'admin.organizations',
    fallbackTitle: 'Organisationshantering',
  },
];
